import { useState } from "react";
import { FaCheck } from "react-icons/fa";

export default function RecruitmentFlow() {
  const steps = [
    { id: 1, title: "Basic Information" },
    { id: 2, title: "Hiring Details" },
    { id: 3, title: "Review & Submit" },
  ];

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    jobName: "",
    jobDescription: "",
    jobRequirement: "",
    jobType: [],
    jobLocation: "Remote, Anywhere",
    recruitmentLimit: "0 to 10 Candidates",
  });

  const goTo = (s) => setStep(s);
  const next = () => setStep((s) => Math.min(s + 1, steps.length));
  const prev = () => setStep((s) => Math.max(s - 1, 1));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const toggleJobType = (type) => {
    setFormData((p) => ({
      ...p,
      jobType: p.jobType.includes(type)
        ? p.jobType.filter((t) => t !== type)
        : [...p.jobType, type],
    }));
  };

  const handleSubmit = () => {
    console.log("Submitting job:", formData);
    alert("Job submitted! ✅\nCheck console for form data");
  };

  return (
    <div className="w-full mx-auto max-w-full lg:max-w-8xl p-6 bg-white font-Nunito rounded-2xl shadow flex flex-col lg:flex-row gap-y-8 lg:gap-x-20">
      {/* Vertical stepper */}
      <div className="flex flex-col items-start w-full lg:w-auto pb-6 lg:pb-0 border-b border-gray-200 lg:border-b-0 lg:border-r lg:pr-8">
        {steps.map((s, i) => {
          const isCompleted = step > s.id;
          const isActive = step === s.id;

          return (
            <div
              key={s.id}
              className="flex flex-col items-start"
            >
              <button
                onClick={() => goTo(s.id)}
                className="flex items-center space-x-3 mb-4 focus:outline-none"
              >
                <div
                  className={`flex items-center justify-center w-10 h-10 rounded-full font-semibold transition-colors ${
                    isActive
                      ? "bg-blue-600 text-white"
                      : isCompleted
                        ? "bg-green-500 text-white"
                        : "bg-gray-200 text-gray-600"
                  }`}
                >
                  {isCompleted ? <FaCheck className="w-5 h-5" /> : s.id}
                </div>
                <span
                  className={`text-sm font-medium ${
                    isActive ? "text-blue-600" : "text-gray-700"
                  }`}
                >
                  {s.title}
                </span>
              </button>

              {i < steps.length - 1 && (
                <div className="w-0.5 bg-gray-300 h-12 ml-5"></div>
              )}
            </div>
          );
        })}
      </div>

      <div className="flex-1 ">
        <label className="block font-medium mb-4">
          <span className="text-red-500">*</span> Indicates a required field
        </label>

        {step === 1 && (
          // <div className="">
          //   <div className=" flex justify-between mb-2">
          //     <div>
          //       <label className="block font-medium mb-2">
          //         Job Name <span className="text-red-500">*</span>
          //       </label>
          //       <p>Enter your name</p>
          //     </div>
          //     <input
          //       name="jobName"
          //       value={formData.jobName}
          //       onChange={handleChange}
          //       placeholder="Enter job name"
          //       className="w-1/2 p-3 border border-[#D8DFEC] rounded-xl mb-4"
          //     />
          //   </div>

          //   <div className="flex justify-between">
          //     <label className="block font-medium mb-2">
          //       Job Description <span className="text-red-500">*</span>
          //     </label>
          //     <textarea
          //       name="jobDescription"
          //       value={formData.jobDescription}
          //       onChange={handleChange}
          //       placeholder="Enter job description"
          //       rows={5}
          //       className="w-1/2 p-3 border border-[#D8DFEC] rounded-xl mb-4"
          //     />
          //   </div>

          //   <div className=" flex justify-between mb-2">
          //     <label className="block font-medium mb-2">
          //       Job Requirement <span className="text-red-500">*</span>
          //     </label>

          //     <textarea
          //       name="jobRequirement"
          //       value={formData.jobRequirement}
          //       onChange={handleChange}
          //       placeholder="Enter job requirement"
          //       rows={5}
          //       className="w-1/2 p-3 border border-[#D8DFEC] rounded-xl"
          //     />
          //   </div>

          //   <div className=" flex justify-between mb-2">
          //     <div>
          //       <label className="block font-medium mb-1">
          //         Job Type <span className="text-red-500">*</span>
          //       </label>
          //       <p className="text-sm text-gray-500 mb-2">
          //         Choose multiple options if applicable
          //       </p>
          //     </div>
          //     <div className="flex flex-wrap gap-4 mb-6">
          //       {[
          //         "Full-Time",
          //         "Part-Time",
          //         "Internship",
          //         "Temporary",
          //         "Contract",
          //       ].map((t) => (
          //         <label
          //           key={t}
          //           className="inline-flex items-center space-x-1"
          //         >
          //           <input
          //             type="checkbox"
          //             checked={formData.jobType.includes(t)}
          //             onChange={() => toggleJobType(t)}
          //             className="w-6 h-6"
          //           />
          //           <span>{t}</span>
          //         </label>
          //       ))}
          //     </div>
          //   </div>

          //   <div className=" flex justify-between">
          //     <div>
          //       <label className="block font-medium mb-1">
          //         Job Location <span className="text-red-500">*</span>
          //       </label>
          //       <p className="text-sm text-gray-500 mb-2">
          //         Choose multiple options if applicable
          //       </p>
          //     </div>
          //     <input
          //       name="jobLocation"
          //       value={formData.jobLocation}
          //       onChange={handleChange}
          //       placeholder="Choose location"
          //       className="w-1/2 p-3 border border-[#D8DFEC] rounded-xl mb-6"
          //     />
          //   </div>

          //   <div className=" flex justify-between mb-4">
          //     <div>
          //       <label className="block font-medium mb-1">
          //         Recruitment Limit
          //       </label>
          //       <p className="text-sm text-gray-500 mb-2">
          //         Mention number of open positions or number of candidates going
          //         to be hired
          //       </p>
          //     </div>

          //     <div className="flex flex-wrap gap-6">
          //       {[
          //         "0 - 10 Candidates",
          //         "10 - 50 Candidates",
          //         "> 50 Candidates",
          //       ].map((limit) => (
          //         <label
          //           key={limit}
          //           className="inline-flex items-center space-x-8"
          //         >
          //           <input
          //             type="radio"
          //             name="recruitmentLimit"
          //             value={limit}
          //             checked={formData.recruitmentLimit === limit}
          //             onChange={handleChange}
          //             className="w-4 h-4"
          //           />
          //           <span>{limit}</span>
          //         </label>
          //       ))}
          //     </div>
          //   </div>
          // </div>
          <div className="space-y-6 ">
            {/* Job Name */}
            <div>
              <label className="block font-medium mb-2">
                Job Name <span className="text-red-500">*</span>
              </label>
              <input
                name="jobName"
                value={formData.jobName}
                onChange={handleChange}
                placeholder="Enter job name"
                className="w-full p-3 border border-[#D8DFEC] rounded-xl"
              />
            </div>

            {/* Job Description */}
            <div>
              <label className="block font-medium mb-2">
                Job Description <span className="text-red-500">*</span>
              </label>
              <textarea
                name="jobDescription"
                value={formData.jobDescription}
                onChange={handleChange}
                placeholder="Enter job description"
                rows={5}
                className="w-full p-3 border border-[#D8DFEC] rounded-xl"
              />
            </div>

            {/* Job Requirement */}
            <div>
              <label className="block font-medium mb-2">
                Job Requirement <span className="text-red-500">*</span>
              </label>
              <textarea
                name="jobRequirement"
                value={formData.jobRequirement}
                onChange={handleChange}
                placeholder="Enter job requirement"
                rows={5}
                className="w-full p-3 border border-[#D8DFEC] rounded-xl"
              />
            </div>

            {/* Job Type */}
            <div>
              <label className="block font-medium mb-1">
                Job Type <span className="text-red-500">*</span>
              </label>
              <p className="text-sm text-gray-500 mb-2">
                Choose multiple options if applicable
              </p>
              <div className="flex flex-wrap gap-4">
                {[
                  "Full-Time",
                  "Part-Time",
                  "Internship",
                  "Temporary",
                  "Contract",
                ].map((t) => (
                  <label
                    key={t}
                    className="inline-flex items-center space-x-2"
                  >
                    <input
                      type="checkbox"
                      checked={formData.jobType.includes(t)}
                      onChange={() => toggleJobType(t)}
                      className="w-5 h-5"
                    />
                    <span>{t}</span>
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block font-medium mb-1">
                Job Location <span className="text-red-500">*</span>
              </label>
              <p className="text-sm text-gray-500 mb-2">
                Choose multiple options if applicable
              </p>

              <select
                name="jobLocation"
                value={formData.jobLocation}
                onChange={handleChange}
                className="w-full p-3 border border-[#D8DFEC] rounded-xl"
              >
                <option value="Remote, Anywhere">Remote, Anywhere</option>
                <option value="Lagos, Nigeria">Lagos, Nigeria</option>
                <option value="Abuja, Nigeria">Abuja, Nigeria</option>
                <option value="Port Harcourt, Nigeria">
                  Port Harcourt, Nigeria
                </option>
                <option value="Hybrid — Lagos">Hybrid — Lagos</option>
                <option value="On-site — Lagos">On-site — Lagos</option>
              </select>
            </div>

            <div>
              <label className="block font-medium mb-1">
                Recruitment Limit
              </label>
              <p className="text-sm text-gray-500 mb-2">
                Mention number of open positions or candidates to be hired
              </p>
              <div className="flex flex-wrap gap-6">
                {[
                  "0 - 10 Candidates",
                  "10 - 50 Candidates",
                  "> 50 Candidates",
                ].map((limit) => (
                  <label
                    key={limit}
                    className="inline-flex items-center space-x-2"
                  >
                    <input
                      type="radio"
                      name="recruitmentLimit"
                      value={limit}
                      checked={formData.recruitmentLimit === limit}
                      onChange={handleChange}
                      className="w-4 h-4"
                    />
                    <span>{limit}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          // <div className="space-y-6">
          //   <div className=" mb-4">
          //     <div>
          //       <label className="block font-medium mb-1">
          //         Job Level <span className="text-red-500">*</span>
          //       </label>
          //       <p className="text-sm text-gray-500 mb-2">
          //         Choose multiple options if applicable
          //       </p>
          //     </div>
          //     <div className="flex flex-wrap gap-4 mb-6">
          //       {["Graduate", "Entry level", "Mid-senior", "Senior"].map(
          //         (t) => (
          //           <label
          //             key={t}
          //             className="inline-flex items-center space-x-1"
          //           >
          //             <input
          //               type="checkbox"
          //               checked={formData.jobType.includes(t)}
          //               onChange={() => toggleJobType(t)}
          //               className="w-6 h-6"
          //             />
          //             <span>{t}</span>
          //           </label>
          //         )
          //       )}
          //     </div>
          //   </div>

          //   <div className="  mb-4">
          //     <div>
          //       <label className="block font-medium mb-2">
          //         Hiring Manager <span className="text-red-500">*</span>
          //       </label>
          //       <p>Enter hiring manager name and id</p>
          //     </div>
          //     <input
          //       name="jobName"
          //       value={formData.jobName}
          //       onChange={handleChange}
          //       placeholder="Enter job name"
          //       className="w-1/2 p-3 border border-[#D8DFEC] rounded-xl mb-4"
          //     />
          //   </div>

          //   <div className="  mb-4">
          //     <div>
          //       <label className="block font-medium mb-2">
          //         Recruiters <span className="text-red-500">*</span>
          //       </label>
          //       <p>choose multiple options if applicable</p>
          //     </div>
          //     <input
          //       name="jobName"
          //       value={formData.jobName}
          //       onChange={handleChange}
          //       placeholder="Enter job name"
          //       className="w-1/2 p-3 border border-[#D8DFEC] rounded-xl mb-4"
          //     />
          //   </div>
          // </div>

          <div className="space-y-8">
            {/* Job Level */}
            <div>
              <label className="block font-medium mb-1">
                Job Level <span className="text-red-500">*</span>
              </label>
              <p className="text-sm text-gray-500 mb-3">
                Choose multiple options if applicable
              </p>

              <div className="flex flex-wrap gap-4">
                {["Graduate", "Entry Level", "Mid-Senior", "Senior"].map(
                  (level) => (
                    <label
                      key={level}
                      className="inline-flex items-center space-x-2"
                    >
                      <input
                        type="checkbox"
                        checked={formData.jobType.includes(level)}
                        onChange={() => toggleJobType(level)}
                        className="w-5 h-5 accent-[#1234CD]"
                      />
                      <span>{level}</span>
                    </label>
                  ),
                )}
              </div>
            </div>

            {/* Hiring Manager */}
            <div>
              <label className="block font-medium mb-1">
                Hiring Manager <span className="text-red-500">*</span>
              </label>
              <p className="text-sm text-gray-500 mb-3">
                Enter hiring manager name and ID
              </p>
              <input
                name="hiringManager"
                value={formData.hiringManager}
                onChange={handleChange}
                placeholder="Enter hiring manager name and ID"
                className="w-full p-3 border border-[#D8DFEC] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1234CD]"
              />
            </div>

            {/* Recruiters */}
            <div>
              <label className="block font-medium mb-1">
                Recruiters <span className="text-red-500">*</span>
              </label>
              <p className="text-sm text-gray-500 mb-3">
                Choose multiple options if applicable
              </p>
              <input
                name="recruiters"
                value={formData.recruiters}
                onChange={handleChange}
                placeholder="Enter recruiter names or IDs"
                className="w-full p-3 border border-[#D8DFEC] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1234CD]"
              />
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="p-4">
            <h2 className="text-xl font-semibold text-[#1E2126] ">Review</h2>

            <div className="space-y-3">
              <h3 className="font-semibold text-gray-800 underline">
                Basic Information
              </h3>
              <p>
                <strong>Job Name:</strong> {formData.jobName || "-"}
              </p>
              <p>
                <strong>Job Description:</strong>{" "}
                {formData.jobDescription || "-"}
              </p>
              <p>
                <strong>Job Requirement:</strong>{" "}
                {formData.jobRequirement || "-"}
              </p>
              <p>
                <strong>Job Type:</strong>{" "}
                {formData.jobType.length ? formData.jobType.join(", ") : "-"}
              </p>
              <p>
                <strong>Job Location:</strong> {formData.jobLocation || "-"}
              </p>
              <p>
                <strong>Recruitment Limit:</strong>{" "}
                {formData.recruitmentLimit || "-"}
              </p>
            </div>

            <div className="space-y-3 pt-4 border-t border-gray-200">
              <h3 className="font-semibold text-gray-800 underline">
                Hiring Details
              </h3>
              <p>
                <strong>Job Level:</strong> {formData.jobLevel || "-"}
              </p>
              <p>
                <strong>Hiring Manager:</strong> {formData.hiringManager || "-"}
              </p>
              <p>
                <strong>Recruiters:</strong> {formData.recruiters || "-"}
              </p>
            </div>

            <div className="mt-6">
              <p className="text-sm text-gray-500">
                Please review all details carefully before submitting.
              </p>
            </div>
          </div>
        )}

        {/* Navigation buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
          <button
            onClick={prev}
            disabled={step === 1}
            className={`px-6 py-3 w-full sm:w-36 rounded-xl ${
              step === 1
                ? "border-[#5570F1] border-2 text-[#5570F1]"
                : "bg-white border text-gray-700"
            }`}
          >
            Previous
          </button>

          {step < steps.length ? (
            <button
              onClick={next}
              className="px-6 py-3 bg-[#1234CD] w-full sm:w-48 text-white rounded-xl"
            >
              Save and Continue
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              className="px-6 py-3 bg-[#1234CD] text-white rounded w-full sm:w-auto"
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
